
    import { computed, defineComponent, onBeforeMount, onUpdated, ref } from 'vue'
    import { useI18n } from 'vue-i18n-composable'

    import { useHeadful } from '@/common/composables/libs/headful'
    import { mountPlayers } from '@/common/util/audio-utils'
    import { useVuetify } from '@/common/composables/libs/vuetify'
    import NotFoundError from '@/common/errors/not-found-error'

    import vuetifyPlugin from '@/app/plugins/vuetify'
    import i18nPlugin from '@/app/lang'
    import { usePagesStore } from '@/app/stores/pages'

    export default defineComponent({
        props: {
            name: {
                type: String,
                required: true
            },
            showTitle: {
                type: Boolean,
                default: false
            },
            notFoundIfRemovable: {
                type: Boolean,
                default: false
            }
        },
        setup (props) {
            const headful = useHeadful()
            const i18n = useI18n()
            const vuetify = useVuetify()
            const pagesStore = usePagesStore()

            const content = ref<HTMLDivElement>()
            const page = computed(() => pagesStore.page(props.name))

            onBeforeMount(async (): Promise<void> => {
                await pagesStore.loadPage(props.name)

                if (page.value.id === 0) {
                    throw new NotFoundError()
                }

                // Pages that are used in another pages contents are marked as not removable
                // If this is the case, just return 404. Those pages content is meant to be
                // used on specific pages.
                if (props.notFoundIfRemovable && !page.value.removable) {
                    throw new NotFoundError('Page not accessible')
                }

                headful({
                    title: `${page.value.title} | ${i18n.t('meta.title')}`
                })
            })

            onUpdated((): void => {
                mountPlayers(content.value, vuetify.theme.dark, i18nPlugin, vuetifyPlugin)
            })

            return {
                content,
                page
            }
        }
    })
